module.exports={
    "DSR": {
        "title": "Doorstep Repair",
        "steps": [
            {
                "title": "Step 1",
                "description": "Enter your details and choose a date and time for your repair with our Authorised Service Partner."
            },
            {
                "title": "Step 2",
                "description": "You will receive an email confirmation with your appointment details and next steps."
            },
            {
                "title": "Step 3",
                "description": "Before your appointment please ensure your device is backed up as all your data may be deleted. If your device has Maintenance Mode, we advise to activate this before handing in your device. Learn more about Maintenance Mode <a href='https://www.samsung.com/ie/support/mobile-devices/what-is-maintenance-mode-and-how-to-use-it-on-your-galaxy-phone-or-tablet/' target='_blank'>here</a>"
            }
        ],
        "disclaimer": "For certain devices, Doorstep Repair includes a convenience surcharge for our Authorised Service Partner come to you."
    },
    "HAPS": {
        "title": "Pick up repair",
        "steps": [
            {
                "title": "Step 1",
                "description": "Enter your contact and product details to book a repair with our Authorised Service Partner."
            },
            {
                "title": "Step 2",
                "description": "Once you've booked your repair, our logistics partner will contact you to arrange the collection of your device."
            },
            {
                "title": "Step 3",
                "description": "Once your product has been inspected, if the issue is found to be out of warranty terms our Authorised Service Partner will contact you with cost and timing for your repair."
            },
            {
                "title": "Step 4",
                "description": "Once the repair is completed you will be contacted to confirm when your device will be returned back to you."
            }
        ],
        "disclaimer": ""
    },
    "HAPSVacuum": {
    "title": "Pick up repair",
    "steps": [
      {
        "title": "Step 1",
        "description": "Enter Contact/Product details to book a collection date for our courier to collect your product."
      },
      {
        "title": "Step 2",
        "description": "Once you've booked our courier will send you a SMS or a DPD app update to confirm date and time for collection."
      },
      {
        "title": "Step 3",
        "description": "Once your product has been inspected, if the issue is found to be out of warranty terms our Authorised Service Partner will contact you with cost and timings for repair. Our Authorised partner might also get in touch if they need further information about your product and the issue you are experiencing."
      },
      {
        "title": "Step 4",
        "description": "Once the repair is completed you will receive an email update confirming your product is on its way back to you. Our courier will then contact you to confirm date and timings for delivery."
      }
    ],
    "disclaimer": ""
  },
    "PS": {
        "title": "Pick up repair",
        "steps": [
            {
                "title": "Step 1",
                "description": "Enter your details providing a phone number and/or email address at which you can be contacted. Our Authorised Service Partner will be in touch to arrange the collection."
            },
            {
                "title": "Step 2",
                "description": "Before your appointment, please ensure your device is backed up as all your data may be deleted.<br/><br/>Your device will be picked up and delivered to our Authorised Service Centre where a Samsung Expert will inspect your device. If your device has Maintenance Mode, we advise to activate this before handing in your device. Learn more about Maintenance Mode <a href='https://www.samsung.com/ie/support/mobile-devices/what-is-maintenance-mode-and-how-to-use-it-on-your-galaxy-phone-or-tablet/' target='_blank'>here</a> "
            },
            {
                "title": "Step 3",
                "description": "Once your device has been inspected, if the issue is found to be out of warranty terms our Authorised Service Partner will contact you with cost and timing for your repair."
            },
            {
                "title": "Step 4",
                "description": "You will be updated once your repair is complete with confirmation of when our Authorised Service Partner will deliver your device back to you."
            }
        ],
        "disclaimer": ""
    },
    "ISR": {
        "title": "In-store Repair",
        "steps": [
            {
                "title": "Step 1",
                "description": "Enter your details and choose a date and time for your appointment at an Authorised Service Centre.<br/><br/>You will receive an email confirmation with your appointment details."
            },
            {
                "title": "Step 2",
                "description": "Before your appointment, please ensure your device is backed up as all your data may be deleted.<br/><br/>If your device has Maintenance Mode, we advise to activate this before handing in your device. Learn more about Maintenance Mode <a href='https://www.samsung.com/uk/support/mobile-devices/what-is-maintenance-mode-and-how-to-use-it-on-your-galaxy-phone-or-tablet/' target='_blank'>here</a>"
            },
            {
                "title": "Step 3",
                "description": "Once your device has been inspected, our Authorised Service Partner will confirm how long it will take to repair your device. If the issue is found to be out of warranty terms they will let you know the cost for your repair."
            },
            {
                "title": "Step 4",
                "description": "Once the repair is completed you will be contacted to confirm how you would like your device to be returned back to you."
            }
        ],
        "disclaimer": ""
    },
    "IH": {
        "title": "In home repair",
        "steps": [
            {
                "title": "Step 1",
                "description": "Enter your contact and product details to book a repair with our Authorised Service Partner."
            },
            {
                "title": "Step 2",
                "description": "Once you've booked your appointment, our Authorised Service Partner will contact you to confirm cost and timings for your repair."
            },
            {
                "title": "Step 3",
                "description": "Our Authorised Service Partner will arrive on the day of your appointment."
            }
        ],
        "disclaimer": ""
    },
    "PSIH": {
        "title": "In home or Pick up repair",
        "steps": [
            {
                "title": "Step 1",
                "description": "Enter your contact and product details to book a repair with our Authorised Service Partner."
            },
            {
                "title": "Step 2",
                "description": "Once you’ve booked your appointment our Authorised Service Partner will contact you to confirm whether your product can be repaired In-home, or whether it needs to be collected to be repaired at our Authorised Service Centre."
            },
            {
                "title": "Step 3",
                "description": "Either our Authorised Service Partner will come to you and fix your product, or our Logistics Partner will arrive to collect your product to be repaired at our Authorised Service Centre and will return it once the repair is complete."
            }
        ],
        "disclaimer": ""
    },
    "PSIHTV": {
      "title": "Pick-up repair",
      "steps": [
        {
          "title": "Step 1",
          "description": "Enter your contact and product details to book a repair with our Authorised Service Partner."
        },
        {
          "title": "Step 2",
          "description": "Once you've requested collection, our Authorised Service Partner will contact you to confirm collection date."
        },
        {
          "title": "Step 3",
          "description": "Once the repair has been completed our Authorised Service Partner will be in touch to arrange return delivery of your product."
        }
      ],
      "disclaimer": ""
    },
    "KISSII": {
        "title": "In home repair",
        "steps": [
            {
                "title": "Step 1",
                "description": "Enter your contact and product details to book a door replacement with our Authorised Service Partner."
            },
            {
                "title": "Step 2",
                "description": "Once you’ve booked your door replacement appointment, our Authorised Service Partner will contact you to confirm details."
            },
            {
                "title": "Step 3",
                "description": "Before your appointment please ensure you have your proof of purchase to hand."
            },
            {
                "title": "Step 4",
                "description": "Our Authorised Service Partner will arrive on the day of your appointment to replace the door of your product and support with next steps."
            }
        ],
        "disclaimer": ""
    },
    "KISS": {
        "title": "In home inspection",
        "steps": [
            {
                "title": "Step 1",
                "description": "Enter your contact and product details to book a product inspection with our Authorised Service Partner."
            },
            {
                "title": "Step 2",
                "description": "Once you've booked your inspection, our Authorised Service Partner will contact you to confirm your appointment."
            },
            {
                "title": "Step 3",
                "description": "Before your appointment please ensure you have your proof of purchase to hand."
            },
            {
                "title": "Step 4",
                "description": "Our Authorised Service Partner will arrive on the day of your appointment to inspect your product and support with next steps."
            }
        ],
        "disclaimer": ""
    },
    "IHTVDA": {
      "title": "In home repair",
      "steps": [
        {
          "title": "Step 1",
          "description": "Enter your contact and product details to book a repair with our Authorised Service Partner.<br/><br/>Choose a preferred date for your appointment."
        },
        {
          "title": "Step 2",
          "description": "Once you've booked your appointment, our Authorised Service Partner will contact you to confirm cost and timings for your repair."
        },
        {
          "title": "Step 3",
          "description": "Our Authorised Service Partner will arrive on the day of your appointment."
        }
      ],
      "disclaimer": ""
    },
    "PSTVDA": {
      "title": "Pick up repair",
      "steps": [
        {
          "title": "Step 1",
          "description": "Enter your contact and product details to book a product collection with our Authorised Service Partner.<br/><br/> Choose a preferred date for your collection."
        },
        {
          "title": "Step 2",
          "description": "Once you’ve requested collection, our Authorised Service Partner will contact you to confirm collection date"
        },
        {
          "title": "Step 3",
          "description": "Once the repair has been completed our Authorised Service Partner will be in touch to arrange return delivery of your product."
        }
      ],
      "disclaimer": ""
    }
}